import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const TasksApi = createApi({
	reducerPath: "Tasks",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1/tasks`,
		credentials: "include",
	}),
	endpoints: (builder) => ({
		createTask: builder.mutation({
			query: (payload) => ({
				url: "",
				method: "POST",
				body: payload,
			}),
		}),
		getAllTasks: builder.query({
			query: ({
				page,
				limit,
				sortBy,
				sortOrder,
				search,
				from,
				to,
				status,
				serviceRequestId,
				assignedToId,
				type,
				poiId,
				priority,
			}) => {
				const queryParams = new URLSearchParams();

				if (page) queryParams.append("page", page);
				if (limit) queryParams.append("limit", limit);
				if (sortBy) queryParams.append("sortBy", sortBy);
				if (sortOrder) queryParams.append("sortOrder", sortOrder);
				if (search) queryParams.append("search", search);
				if (from) queryParams.append("fromDate", from);
				if (to) queryParams.append("toDate", to);
				if (status) queryParams.append("status", status);
				if (serviceRequestId)
					queryParams.append("serviceRequestId", serviceRequestId);
				if (assignedToId) queryParams.append("assignedToId", assignedToId);
				if (type) queryParams.append("type", type);
				if (poiId) queryParams.append("poiId", poiId);
				if (priority) queryParams.append("priority", priority);

				return `/reporter?${queryParams.toString().replace(/%2C/g, ",")}`;
			},
		}),
		getSingleTask: builder.query({
			query: (id) => `/${id}`,
		}),
		deleteTask: builder.mutation({
			query: (id) => ({
				url: `/${id}`,
				method: "DELETE",
			}),
		}),
		editTask: builder.mutation({
			query: ({ id, payload }) => ({
				url: `/${id}`,
				method: "PATCH",
				body: payload,
			}),
		}),
		bulkCreateTasks: builder.mutation({
			query: (tasks) => ({
				url: "/bulk/json",
				method: "POST",
				body: tasks,
			}),
		}),
		bulkCreateTasksFromExcel: builder.mutation({
			query: (file) => {
				const formData = new FormData();
				formData.append("file", file);
				return {
					url: "/bulk/excel",
					method: "POST",
					body: formData,
				};
			},
		}),
		getTasksByFilter: builder.query({
			query: ({
				limit = 10,
				page = 1,
				sortBy = "",
				sortOrder = "",
				search = "",
				status = "",
				assignedToId = "",
				type = "",
				showBy = "",
				poiId,
				fromDate,
				toDate,
				priority = "",
			}) => {
				const queryParams = new URLSearchParams();

				queryParams.append("limit", limit);
				queryParams.append("page", page);
				if (sortBy) queryParams.append("sortBy", sortBy);
				if (sortOrder) queryParams.append("sortOrder", sortOrder);
				if (search) queryParams.append("search", search);
				if (status) queryParams.append("status", status);
				if (assignedToId) queryParams.append("assignedToId", assignedToId);
				if (type) queryParams.append("type", type);
				if (showBy) queryParams.append("showBy", showBy);
				if (poiId) queryParams.append("poiId", poiId);
				if (fromDate) queryParams.append("fromDate", fromDate);
				if (toDate) queryParams.append("toDate", toDate);
				if (priority) queryParams.append("priority", priority);

				return `?${queryParams.toString().replace(/%2C/g, ",")}`;
			},
		}),
	}),
});

export const {
	useGetAllTasksQuery,
	useCreateTaskMutation,
	useDeleteTaskMutation,
	useGetSingleTaskQuery,
	useEditTaskMutation,
	useGetTasksByFilterQuery,
	useBulkCreateTasksMutation,
	useBulkCreateTasksFromExcelMutation,
} = TasksApi;
